<template>
  <v-container>
    <v-card class="mx-auto mt-16 py-2 px-6" max-width="400">
      <v-card-item>
        <v-card-title>
          New Account
        </v-card-title>
      </v-card-item>
      <!-- <v-card-text>
        We will periodically be opening access
      </v-card-text> -->
      <v-form @submit.prevent="onSubmit">
        <v-text-field
          v-model="email"
          name="email"
          label="Email"
          type="text"
          placeholder="Email"
          variant="outlined"
          required
          :rules="emailRules"
          autofocus
        ></v-text-field>

        <v-text-field
          v-model="username"
          name="username"
          label="Username"
          type="text"
          placeholder="Username"
          variant="outlined"
          required
          :rules="usernameRules"
        ></v-text-field>

        <v-text-field
          v-model="first"
          name="first"
          label="First Name"
          type="text"
          placeholder="First Name"
          variant="outlined"
          required
          :rules="firstRules"
        ></v-text-field>

        <v-text-field
          v-model="last"
          name="last"
          label="Last Name"
          type="text"
          placeholder="Last Name"
          variant="outlined"
        ></v-text-field>
        
        <v-text-field
          v-model="password"
          name="password"
          label="Password"
          type="password"
          placeholder="Password"
          variant="outlined"
          required
          :rules="passwordRules"
          @keydown.enter="register"
        ></v-text-field>

        <v-text-field
          v-model="confirmPassword"
          name="confirmPassword"
          label="Confirm Password"
          type="password"
          placeholder="Confirm Password"
          variant="outlined"
          required
          :rules="confirmPasswordRules"
          @keydown.enter="register"
        ></v-text-field>

        <!-- <v-text-field
          v-model="code"
          name="code"
          label="Invite Code"
          type="text"
          placeholder="Invite Code"
          variant="outlined"
          required
          @keydown.enter="register"
        ></v-text-field> -->

        <v-checkbox
          v-model="terms"
          label=""
          required
          @keydown.enter="register"
        >
          <template v-slot:label>
            I agree to the&nbsp;<a href="https://missionsquad.ai/privacy" target="_blank">terms and conditions</a>.
          </template>
        </v-checkbox>

        <v-checkbox
          v-model="advice"
          label=""
          required
          @keydown.enter="register"
        >
          <template v-slot:label>
            I understand that stonkreport.com does not provide investment advice and that I am solely responsible for my own investment decisions.
          </template>
        </v-checkbox>
        

      </v-form>
      <v-card-actions>
        <v-btn
          @click.stop.prevent="register"
          text="Register"
          :disabled="registerDisabled()"
        ></v-btn>
      </v-card-actions>
    </v-card>
    <div class="mx-auto mt-8 pa-2 access-text">
      <p>We're periodically opening access to new users. You can <router-link to="/request">request access by submitting your email address here</router-link>.</p>
    </div>
  </v-container>
</template>
<script lang="ts">
// import { checkEmail } from '@/utils/general'
import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'
import { useRouter } from 'vue-router'

export function checkEmail(v: string) {
  return /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(v)
}

export function checkName(v: string) {
  return /^[a-zA-Z]{2,}$/.test(v)
}

@Options({
  computed: {
    breakpoint(): string {
      return this.$vuetify.display.name
    },
    ...mapState(['username', 'authenticated'])
  },
  watch: {
    breakpoint(value: any) {
      // change layout
    },
    // authenticated(value: boolean) {
    //   if (value) {
        
    //   }
    // }
  }
})
export default class RegisterView extends Vue {
  public breakpoint!: string
  public authenticated!: boolean
  public email: string = ''
  public username: string = ''
  public first: string = ''
  public last: string = ''
  public password: string = ''
  public confirmPassword: string = ''
  // public code: string = ''
  public terms: boolean | null = false
  public advice: boolean | null = false
  public authFailureMessage: string = ''
  private router = useRouter()

  public emailRules = [
    (v: string) => !!v || 'Email is required',
    (v: string) => checkEmail(v) || 'Invalid email address.',
  ]

  public usernameRules = [
    (v: string) => !!v || 'Username is required',
    (v: string) => !checkEmail(v) || 'Username is not an email address.',
  ]

  public firstRules = [
    (v: string) => !!v || 'First name is required',
    (v: string) => checkName(v) || 'First name must be at least 2 characters long and only contain letters.',
  ]

  public passwordRules = [
    (v: string) => !!v || 'Password is required',
    (v: string) => (v && v.length >= 8) || 'Password must be at least 8 characters.',
  ]

  public confirmPasswordRules = [
    (v: string) => !!v || 'Confirm password is required',
    (v: string) => (v && v === this.password) || 'Passwords must match.',
  ]

  public async mounted() {
    await this.$store.dispatch('checkAuth')
  }

  public onSubmit() {
    console.log('?')
  }

  public registerDisabled() {
    const username = this.username.trim()
    const email = this.email.trim()
    const password = this.password.trim()
    const confirmPassword = this.confirmPassword.trim()
    // const code = this.code.trim()
    if (username !== '' && password !== '' && password === confirmPassword && email !== '' && this.terms && this.advice) {
      return false
    } else {
      return true
    }
  }
  
  public async register() {
    // sign in here
    const username = this.username.trim()
    const email = this.email.trim()
    const first = this.first.trim()
    const last = this.last.trim()
    const password = this.password.trim()
    const confirmPassword = this.confirmPassword.trim()
    // const code = this.code.trim()
    if (username !== '' && first !== '' && password !== '' && password === confirmPassword && email !== '' && this.terms && this.advice) {
      const { success, message } = await this.$store.dispatch('register', { username, first, last, password, email })
      this.password = ''
      if (success) {
        await this.router.push('/stonks')
        console.log(`pushing route to /`)
      }
    }
  }
}
</script>
<style lang="scss">
.access-text {
  max-width: 400px;
}
</style>